import { InputUpload, ProgressBar, InputId } from '@dunia/ui';
import * as conditions from '@/forms/conditions';
import getFileName from '@/forms/helpers/get-file-name';

const defaultValidations = [
  data => ({
    errorMessage: `The file exceeds the limit of ${data['max-file-size']} bytes`,
    condition: conditions.maxFileSizeCondition(data['max-file-size']),
    name: 'max-file-size',
  }),
  {
    errorMessage: 'Oops! Something went wrong.',
    condition: conditions.checkUploadStatusType(5),
    name: 'failed-upload-validation',
  },
  {
    errorMessage: 'Oops! Wrong file format.',
    condition: conditions.checkUploadStatusType(4),
    name: 'invalid-file-type-postvalidation',
  },
];

const getPreValidations = context => [
  {
    errorMessage: `The file exceeds the limit of ${context.$props.maxFileSize} bytes`,
    condition: conditions.maxFileSizeCondition(context.$props.maxFileSize),
    name: 'max-file-size',
  },
];

const getPrevalidationResult = (value, preValidations) => {
  let result = {
    preValidationStatus: true,
  };

  preValidations.forEach((validation) => {
    if (!validation.condition(value)) {
      result = {
        preValidationStatus: false,
        errorMessage: validation.errorMessage,
        validationName: validation.name,
      };
    }
  });

  return result;
};

const uploadOnChange = comp => async (value) => {
  const {
    onChange,
    uploadService,
    uploadedCallback,
  } = comp.$props;
  const prevalidationResult = getPrevalidationResult(value, getPreValidations(comp));

  if (!prevalidationResult.preValidationStatus) {
    return onChange(prevalidationResult);
  }

  comp.isUploading = true;

  const responseFile = await uploadService(
    value,
    (progress) => { comp.progress = progress; },
  );

  comp.isUploading = false;

  onChange(responseFile);
  return uploadedCallback();
};

export default {
  name: 'UploadWrapper',
  defaultValidations,
  data: () => ({
    isUploading: false,
    progress: 0,

  }),

  render(createElement) {
    return createElement(this.isIdUpload ? InputId : InputUpload, {
      props: {
        fieldId: this.$props.fieldId,
        name: this.$props.name,
        label: this.$props.label,
        errorMessage: this.$props.errorMessage,
        isDisabled: this.$props.isDisabled,
        validationState: this.$props.validationState,
        onChange: uploadOnChange(this),
        changeable: this.$props.changeable,
        accept: this.$props.accept,

        fileName: getFileName(this.$props.name),
        percentUploaded: this.$data.progress,
        isUploading: this.$data.isUploading,
        side: this.$props.idSide,
      },

      scopedSlots: {
        progress: () => createElement(ProgressBar, {
          props: {
            current: this.$data.progress,
            total: 100,
          },
        }),
      },
    });
  },

  computed: {
    isIdUpload() {
      return !!this.idSide;
    },
  },

  props: {
    maxFileSize: {
      type: Number,
      default: 15360,
    },
    uploadService: {
      type: Function,
      required: true,
    },
    uploadedCallback: {
      type: Function,
      default: () => {},
    },
    fieldId: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    errorMessage: {
      type: String,
      required: false,
    },
    isDisabled: {
      type: Boolean,
      required: true,
    },
    validationState: {
      type: String,
      required: true,
    },
    onChange: {
      type: Function,
      default: () => {},
      required: true,
    },
    changeable: {
      type: Boolean,
      required: false,
    },
    accept: {
      type: String,
    },
    idSide: {
      type: String,
      default: null,
    },

  },
};
